module.exports = __webpack_public_path__ + "web/img/active.0431d61a.png";